<div class="skeleton" *ngIf="!interaction">
  <div class="header-wrap content-wrap-inner compact">
    <ion-skeleton-text animated class="skeleton-line" style="width: 100%; height: 2rem; margin-bottom: 1rem;"></ion-skeleton-text>
    <ion-skeleton-text animated class="skeleton-line" style="width: 100%; height: 2rem; margin-bottom: 1rem;"></ion-skeleton-text>
    <ion-skeleton-text animated class="skeleton-line" style="width: 100%; height: 2rem; margin-bottom: 1rem;"></ion-skeleton-text>
  </div>
</div>

<app-interaction
  *ngIf="interaction"
  [interaction]="interaction"
  [isResults]="isResultsActive"
  [isWordCloudReady]="isWordCloudReady"
  [style.--card-wrapper-max-height]="'586px'"
></app-interaction>
